import { FrontendBIM360Modelset } from './frontend/FrontendBIM360Modelset';

export class BIM360Modelset {
    public id: string = '';
    public name: string = '';
    public description: string = '';
    public modelSetType: string = '';
    public containerId: string = '';
    public isDisabled: boolean = false;

    public toAutodeskJSON(modelSet: FrontendBIM360Modelset): any {
        return {
            data: {
                oldName: this.name,
                oldDescription: this.description,
                newName: modelSet.name,
                newDescription: modelSet.description
            }
        }
    }

    public static fromAutodeskJSON(json: any): BIM360Modelset {
        let modelSet = new BIM360Modelset();
        modelSet.id = json.modelSetId;
        modelSet.name = json.name;
        modelSet.description = json.description;
        modelSet.modelSetType = json.modelSetType;
        modelSet.containerId = json.containerId;
        modelSet.isDisabled = json.isDisabled;
        return modelSet;
    }
}


